const hasAvatar = (profile: any) => {
    return profile?.avatar?.length
}

export const getSmallestImage = (files: any[]) => {
    if (!(files && files.length)) {
        return;
    }
    const sorted = files.sort((a, b) => a.width - b.width);
    return sorted[0];
};


/**
 * Вычисляет основные поля дизайнера
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 */
export function computeDesigner(designer: any, opt?: any): any {
    const [name, surName, middleName] = [designer?.name, designer?.surName, designer?.middleName];
    const { showFullName } = opt || {};
    return {
        designerId: designer?.accountId ?? 'undefined',
        accountId: designer?.accountId ?? 'undefined',
        key: designer?.designerId ?? Date.now(),
        identifier: designer?.designerId ?? Date.now(),
        avatar: hasAvatar(designer)
            ? getSmallestImage(designer?.avatar)
            : undefined,
        fullName: showFullName ?  (name + ' ' + surName + ' ' + middleName) : (name + ' ' + surName),
        name,
        surName,
        middleName,
        nickName: designer?.nickName,
        friendlyURLPath: designer?.friendlyURLPath,
        about: designer?.about ?? '',
        globalType: designer?.globalType ?? '',
        //@ts-ignore
        globalTypes: designer?.globalTypes ?? [],
        contextId: designer?.contextEntityId ?? '',
        socialNetworks: Array.isArray(designer?.socialNetworks)
            ? designer?.socialNetworks?.map((value: any) => ({ type: value.key, link: value.link })) ?? []
            : [],
        //todo add position to designer
        //@ts-ignore
        position: designer?.position ?? '',
        //@ts-ignore
        country: designer?.country?.name ?? '',
    };
}

export const applicationBgMap = {
    'deziiign/main': '#fefefe',
}

export const getContextBg = (props: any, params: any) => {
    const { definedApp } = params
    // console.log('getContextBg!!!', params);
    return definedApp
        ? applicationBgMap[definedApp.application as keyof typeof applicationBgMap]
        : '#e7e7e7';
}const hasAvatar = (profile: any) => {
    return profile?.avatar?.length
}

export const getSmallestImage = (files: any[]) => {
    if (!(files && files.length)) {
        return;
    }
    const sorted = files.sort((a, b) => a.width - b.width);
    return sorted[0];
};


/**
 * Вычисляет основные поля дизайнера
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 */
export function computeDesigner(designer: any, opt?: any): any {
    const [name, surName, middleName] = [designer?.name, designer?.surName, designer?.middleName];
    const { showFullName } = opt || {};
    return {
        designerId: designer?.accountId ?? 'undefined',
        accountId: designer?.accountId ?? 'undefined',
        key: designer?.designerId ?? Date.now(),
        identifier: designer?.designerId ?? Date.now(),
        avatar: hasAvatar(designer)
            ? getSmallestImage(designer?.avatar)
            : undefined,
        fullName: showFullName ?  (name + ' ' + surName + ' ' + middleName) : (name + ' ' + surName),
        name,
        surName,
        middleName,
        nickName: designer?.nickName,
        friendlyURLPath: designer?.friendlyURLPath,
        about: designer?.about ?? '',
        globalType: designer?.globalType ?? '',
        //@ts-ignore
        globalTypes: designer?.globalTypes ?? [],
        contextId: designer?.contextEntityId ?? '',
        socialNetworks: Array.isArray(designer?.socialNetworks)
            ? designer?.socialNetworks?.map((value: any) => ({ type: value.key, link: value.link })) ?? []
            : [],
        //todo add position to designer
        //@ts-ignore
        position: designer?.position ?? '',
        //@ts-ignore
        country: designer?.country?.name ?? '',
    };
}

export const applicationBgMap = {
    'deziiign/main': '#fefefe',
}

export const getContextBg = (props: any, params: any) => {
    const { definedApp } = params
    // console.log('getContextBg!!!', params);
    return definedApp
        ? applicationBgMap[definedApp.application as keyof typeof applicationBgMap]
        : '#e7e7e7';
}